module.exports = __webpack_public_path__ + "static/media/100-pakistan.9659e1c6.svg";